import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SnakePortfolio from './pages/SnakePortfolio';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SnakePortfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
